module.exports = __webpack_public_path__ + "static/media/blueShape-mobile.34b31e79.png";